import React, { useEffect, useState } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { getInfoLocalStorage } from '../redux/api/config'
import { checkAccess } from '../services/accessControl'

const ProtectedRoute = ({ children, resourceKey }) => {
    const location = useLocation()
    const { isAuth } = getInfoLocalStorage()
    const [allowed, setAllowed] = useState(null)

    useEffect(() => {
        let mounted = true
        const verify = async () => {
            // For operacional pages, always rely on URL-based access (skip feature checks)
            const isOperacional = /^\/operacional(\/|$)/.test(location.pathname)
            const keyForCheck = isOperacional ? undefined : resourceKey
            const ok = await checkAccess(keyForCheck, location.pathname)
            if (mounted) setAllowed(ok)
        }
        verify()
        return () => { mounted = false }
    }, [resourceKey, location.pathname])

    if (!isAuth) {
        return <Navigate to="/login" state={{ from: location }} replace />
    }

    if (allowed === null) {
        return null
    }

    if (!allowed) {
        return <Navigate to="/acesso/solicitar" state={{ from: location.pathname }} replace />
    }

    return children
}

export default ProtectedRoute


